import { Cahier } from '../../habilitation/models/cahier.model';
import { Produit } from '../../habilitation/models/produit.model';
import { Activite } from '../../habilitation/models/activite.model';
import { RefMouvement } from './ref-mouvement.model';
import { NatureControle } from './nature-controle.model';
import { ObjetControle } from './objet-controle.model';
import { PressionDeclencheur } from './pression-declencheur.model';
import { DataIdArrayConverterFactory, DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Campagne } from './campagne.model';

export class PressionControle {
    static jsonMap = {
        id: 'id',
        estInterne: 'estInterne',
        libelle: 'libelle',
        nature: { key: 'controleNature', converter: new (DataIdConverterFactory.build(NatureControle, 'naturesControle'))() },
        objet: { key: 'controleObjet', converter: new (DataIdConverterFactory.build(ObjetControle, 'objetsControle'))() },
        cdcs: { key: 'cahiers', converter: new (DataIdArrayConverterFactory.build(Cahier, 'cahiers'))() },
        codesProduit: { key: 'produits' },
        activites: { key: 'activites', converter: new (DataIdArrayConverterFactory.build(Activite, 'activites'))() },
        declencheur: { key: 'declencheur', converter: new (DataIdConverterFactory.build(PressionDeclencheur, 'pressionDeclencheurs'))() },
        typesMouvement: { key: 'typesMouvement', converter: new (DataIdArrayConverterFactory.build(RefMouvement, 'refMouvements'))() },
        pression: 'pression',
        estAnneeCivile: 'estAnneeCivile',
        campagnes: { key: 'campagnes', converter: new (DataIdArrayConverterFactory.build(Campagne, 'campagnes'))() }
    };

    id: number = undefined;
    estInterne: boolean = undefined;
    libelle: string = undefined;
    nature: NatureControle;
    objet: ObjetControle;
    cdcs: Cahier[] = undefined;
    codesProduit: string[] = undefined;
    activites: Activite[];
    declencheur: PressionDeclencheur;
    typesMouvement: RefMouvement[];
    pression: number = undefined;
    estAnneeCivile: boolean = undefined;
    campagnes: Campagne[];

    produits: Produit[] = [];
}
